export const getStyleValue = (key: string): string => {
  return getComputedStyle(document.documentElement).getPropertyValue(key).trimStart();
};
